import { ChangeDetectorRef, Component, ElementRef, Renderer2 } from '@angular/core';
import { ICellEditorAngularComp } from 'ag-grid-angular';


@Component({
    selector: 'app-input-cell-editor',
    template: `
    <div class="custom-renderer-ag">
         <input *ngIf="params.data.editFlag" [maxLength]="config && config.maxLength?config.maxLength:9" type="text" #inputElement class="form-control form-ctrl" style="border-bottom: inherit !important;" [disabled]="params.node.data.showEditButton" [(ngModel)]="selectedValue" (ngModelChange)="onValueChange($event)" onkeypress="return event.keyCode === 8 || (event.charCode >= 48 && event.charCode <= 57) || (event.target.value.indexOf('.') < 0 && event.target.value.length>0 && event.charCode === 46)">
         <div *ngIf="!params.data.editFlag" [innerText]="selectedValue"></div>
</div>
  `,
})
export class InputFieldRenderer implements ICellEditorAngularComp {

    config: any;

    params: any;
    // rendererParams: any;
    public selectedValue: any;
    // private inputElement: HTMLInputElement;

    constructor(private elRef: ElementRef, private renderer: Renderer2) { }

    agInit(params: any): void {
        this.params = params;
        this.selectedValue = params.value;
        this.config = params.colDef?.cellRendererParams;
        // this.rendererParams = params.colDef?.cellRendererParams;
        // debugger
        // this.inputElement = this.elRef.nativeElement.querySelector('input');;
        // this.renderer.listen(this.inputElement, 'focus', () => {
        //     // Handle focus event if necessary
        // });
    }

    refresh(params: any) {
        this.params = params;
        this.selectedValue = params.value;
        return true;
    }

    // ngAfterViewInit() {
    //     setTimeout(() => this.params.colDef.field === this.rendererParams[0] ? this.inputElement.focus() : null, 0);
    // }

    getValue(): any {
        return this.selectedValue;
    }

    isPopup(): boolean {
        return true; // Return true if you want popup editing style
    }

    // Optional methods
    // You can add additional methods like focusIn, focusOut, etc. as needed

    onValueChange(newValue: any): void {
        this.params.setValue(newValue);
        // this.params.api.stopEditing();
    }

    // Implement other necessary methods from ICellEditorAngularComp interface
}
